// extracted by extract-css-chunks-webpack-plugin
module.exports = {"slider":"Ecik-","tablet":"i09Fl","facet-label":"EFvbI"};